
import PieChart from '@/components/overview/PieChart.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IConsultantBarometerKPIResult } from '../../shared/contracts/KPIContract';
import Speedometer from '../overview/Speedometer.vue';
import DriverBreakdown from './DriverBreakdown.vue';

@Component({
  components: {
    PieChart,
    Speedometer,
    DriverBreakdown
  }
})
export default class Dashboard extends Vue {
  @Prop() kpi: IConsultantBarometerKPIResult;
}
